import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { AccountDeviceEffects } from "./+state/effects";
import { AccountDeviceFacade } from "./+state/facades";
import { AccountDeviceService } from "./+state/services";

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AccountDeviceEffects])],
  providers: [AccountDeviceFacade, AccountDeviceService]
})
export class AccountDeviceDataAccessModule {}
